import type { SVGProps } from 'react';
const SvgCameraFront = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#camera_front_svg__a)">
      <path
        fill="currentColor"
        d="M10 20H5v2h5v2l3-3-3-3v2Zm4 0v2h5v-2h-5ZM12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8Zm5-8H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2ZM7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2Z"
      />
    </g>
    <defs>
      <clipPath id="camera_front_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCameraFront;
